import vue from '@/main'

import axios from "../../axios"
import store from "../../store/store"

axios.interceptors.request.use(
  config => {
    if (store.state.showLoadingOverlay) {
      vue.$vs.loading({
        type: 'radius'
      });
    }

    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }

    return config
  },
  error => {
    Promise.reject(error)
  })

axios.interceptors.response.use(
  response => {
    vue.$vs.loading.close()

    return response
  },
  async error => {
    vue.$vs.loading.close()
    const { config, response } = error
    const originalRequest = config

    vue.$emit('api-response', response);

    if (response && response.status === 401) {
      if (
        response.data.status === 'Unauthorized' ||
        response.data.status === 'Authorization Token not found' ||
        response.data.status === 'Token is Expired' ||
        response.data.status === 'Token is Invalid'
      ) {
        localStorage.removeItem("accessToken")
        vue.$vs.loading.close()
        return vue.$router.push('/login')
      }

      for (const error of response.data.errors) {
        console.error(error.message)

        if (error.message === 'Token has expired') {
          const accessToken = await store.dispatch("auth/refreshAccessToken")
          originalRequest.headers.Authorization = 'Bearer ' + accessToken

          return Promise.resolve(axios(originalRequest))
        }

        if (error.message === 'Unauthorized' || error.message === 'Authorization Token not found') {
          localStorage.removeItem("accessToken")
          vue.$vs.loading.close()
          return vue.$router.push('/login')
        }
      }
    }

    return Promise.reject(error)
  })

export default axios
